import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { WIDTH_COLUMN, WIDTH_PERCENT_LEFT_HEADER } from '../const';
import { setterCalendar } from '../store/slices/calendarSlice';
import { setterGantScroll } from '../store/slices/gantScrollSlice';
import { setterGant } from '../store/slices/gantSlice';
import { useSettingsOnce } from './useSettingsOnce';

let isApplied = false;

export const useSettingsAppliedToRedux = (authorId: string) => {
    const dispatch = useDispatch();

    const { settingGant } = useSettingsOnce();

    useEffect(() => {
        if (isApplied || !authorId) {
            return;
        }

        const settings = settingGant?.data.userSettings?.[authorId];

        if (settings) {
            isApplied = true;

            dispatch(
                setterGantScroll({
                    currentScrollX: settings.gantScrollX,
                }),
            );

            dispatch(
                setterGant({
                    widthLeftHeader:
                        settings.projectsTreePanelWidth ?? (window.innerWidth / 100) * WIDTH_PERCENT_LEFT_HEADER,
                    widthColumn: settings.gantWidthColumn ?? WIDTH_COLUMN,
                    modeTimeLine: settings.gantModeTimeline ?? 'timeline',
                    headerType: settings.gantHeaderType ?? 'day',
                    calendarOffsetDays: settings.calendarOffsetDays ?? 0,
                }),
            );

            dispatch(
                setterCalendar({
                    currentDate: settings.calendarCurrentDate ?? undefined,
                    scheduleScale: settings.calendarScale ?? 'day',
                }),
            );
        }
    }, [settingGant, authorId]);

    return isApplied;
};
